import { gql } from "@apollo/client";

export const GENERATE_ADD_ONS_REPORT_QUERY = gql`
  query generateAddOnsReport($fromDate: String!, $toDate: String!) {
    generateAddOnsReport(fromDate: $fromDate, toDate: $toDate) {
      key
      message
    }
  }
`;